import React, { useState } from "react";
import { ErrorContext, type Error } from "./ErrorContext";
import { AlertDialog } from "../../components/dialogs/AlertDialog";
import { v4 as uuidv4 } from "uuid";

type Props = {
  children?: React.ReactNode;
};

export const ErrorContextProvider = (props: Props) => {
  const [error, setError] = useState<Error & { key: string }>();

  const handleError = (err: Error) => {
    if (error) return;
    setError({ ...err, key: uuidv4() });
  };

  const handleClose = () => {
    setError(undefined);
  };

  return (
    <>
      <ErrorContext.Provider value={{ setError: handleError }}>
        {props.children}
      </ErrorContext.Provider>
      <AlertDialog
        key={error?.key}
        handleClose={handleClose}
        open={!!error}
        title={error?.title}
        message={error?.message}
      />
    </>
  );
};
